import type * as timePanelData from "./utils/loadTimePanelData";
import { LazyAction, LazyModule } from "owa-bundling";

// Idle initialization must not import the pane's UI and interaction orchestrators.
const dataLazyModule: LazyModule<typeof timePanelData> = new LazyModule(() => import(/* webpackChunkName: "TimePanelData" */ "./utils/loadTimePanelData"), { name: "TimePanelData" });

export const lazyInitializeTimePanelData: LazyAction<typeof timePanelData.loadTimePanelData, typeof dataLazyModule> = new LazyAction(dataLazyModule, m => m.loadTimePanelData);
